export { Warehouse2DialogComponent } from './warehouse2-dialog.component';
export { Warehouse2Component } from './warehouse2.component';
